import { Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'app-field-radios',
    templateUrl: './field-radios.component.html',
    styleUrls: ['./field-radios.component.scss'],
    standalone: false
})
export class FieldRadiosComponent implements OnInit, OnChanges {
    @Input() options: [{ title: string; value: any }];
    @Input() optionWidth: number;
    @Input() optionColumnWidth?: string;
    @Input() fillWidth?: boolean;
    @Input() canUncheck?: boolean = false;
    @Input() readOnly?: boolean;
    @Input() model: any;
    @Input() label?: string;
    @Input() error?: string;
    @Input() optionalString?: string;
    @Input() optionalReadOnlyOnOtherModelValue?: boolean = false;
    @Input() optionalReadOnlyValue?: string;
    @Output() modelChange = new EventEmitter();
    @Output() emitBlur = new EventEmitter();

    localModel: any;
    localOptionalValueReadOnly: boolean;

    constructor() { }

    ngOnInit(): void { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.optionalInputModel || changes.type) {
            let preventEmit = true;
            if (changes.type && changes.type.previousValue) {
                preventEmit = false;
            }
        }

        if (changes.model) {
            this.localModel = this.model;
        }
    }

    emit($event) {
        if (this.readOnly) {
            return;
        }
        this.modelChange.emit($event);
    }
}
